export const NAME_COLUMN_XS = 6;

export const CODE_COLUMN_XS = 2;

export const BUTTONS_COLUMN_XS = 12 - NAME_COLUMN_XS - CODE_COLUMN_XS;
